import Endpoint from "@/utils/endPoint";

const postListEndpoint = new Endpoint("/posts/teachers/klasses/{klassId}");
const createPostEndpoint = new Endpoint("/posts/teachers/");
const postEndpoint = new Endpoint("/posts/teachers/{postId}");
const postLikeEndpoint = new Endpoint("/posts/teachers/{postId}/like");
const postUnLikeEndpoint = new Endpoint("/posts/{postId}/like");

const announcementListEndpoint = new Endpoint("/posts/teachers/announcements/klasses/{klassId}/");
const createAnnouncementEndpoint = new Endpoint("/posts/teachers/announcements");
const activateAnnouncementEndpoint = new Endpoint("/posts/teachers/announcements/activate/{postId}");
const deactivateAnnouncementEndpoint = new Endpoint("/posts/teachers/announcements/deactivate/{postId}");



const statsLatestEndpoint = new Endpoint("/posts/teachers/stats/latest");
const statsHistoryEndpoint = new Endpoint("/posts/teachers/stats/history");

class PostService {
    async getPostListService(params) {
        const result = await postListEndpoint.get(params);
        return result;
    }

    async createPostService(params) {
        const result = await createPostEndpoint.post(params);
        return result;
    }

    async delPostService(params) {
        const result = await postEndpoint.del(null, params);
        return result;
    }

    async getPostService(params) {
        const result = await postEndpoint.get(params);
        return result;
    }

    async getAnnouncementListService(params) {
        const result = await announcementListEndpoint.get(params);
        return result;
    }

    async createAnnounceService(params) {
        const result = await createAnnouncementEndpoint.post(params);
        return result;
    }

    async activateAnnounceService(params) {
        const { postId, ...param } = params;
        const result = await activateAnnouncementEndpoint.put(param, { postId });
        return result;
    }

    async deactivateAnnounceService(params) {
        const { postId, ...param } = params;
        const result = await deactivateAnnouncementEndpoint.put(param, { postId });
        return result;
    }

    async praisePostService(params) {
        const { postId, ...param } = params;
        const result = await postLikeEndpoint.put(param, { postId });
        return result;
    }

    async cancelPraisePostService(params) {
        const { postId, ...param } = params;
        const result = await postUnLikeEndpoint.del(param, { postId });
        return result;
    }


    async getLatestStatsService(params) {
        const result = await statsLatestEndpoint.get(params);
        return result;
    }


    async getHistoryStatsService(params) {
        const result = await statsHistoryEndpoint.get(params);
        return result;
    }

}

export default new PostService();
